import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import Disclaimer from './Disclaimer';
import TermsOfUse from './TermsOfUse';
import { CommonStore } from '../stores/commonStore';

@observer
class Footer extends Component {
  render() {
    const { commonStore } = this.props;
    return (
      <div className="section">
        {/* <Disclaimer commonStore={commonStore} />
        <TermsOfUse commonStore={commonStore} /> */}
      </div>
    );
  }
}

export default Footer;

Footer.propTypes = {
  commonStore: PropTypes.instanceOf(CommonStore).isRequired,
};
